const list = {
    path: 'serviceproducts_omt',
    component: resolve => require(['@/pages/admin/trading/serviceproducts_omt'], resolve)
}
export default list
//服务产品订单管理